import React from 'react'
import { Link } from 'react-router-dom'

export const HelpPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-space p-3 sm:p-4 lg:p-6">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-2xl sm:text-3xl font-bold esales-text font-display mb-2">Help & Support</h1>
        <p className="text-muted-foreground mb-8">Quick reference and support for the Sachin Bookshop POS system.</p>

        <div className="glass-card p-6 space-y-6">
          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">Getting started</h2>
            <p className="text-muted-foreground text-sm">
              Use <Link to="/pos" className="text-primary hover:underline">POS</Link> for sales, <Link to="/inventory" className="text-primary hover:underline">Inventory</Link> to manage products and stock, and <Link to="/reports" className="text-primary hover:underline">Reports</Link> for insights. Admins can manage employees and system settings.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">Security</h2>
            <p className="text-muted-foreground text-sm">
              Session timeout, login attempt limiting, and audit logs are configured under Settings → Security and Settings → Audit Log. Quick login with PIN can be set per employee by an admin.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">Contact</h2>
            <p className="text-muted-foreground text-sm">
              For technical support or feature requests, contact your system administrator or the Sachin Bookshop support team.
            </p>
          </section>
        </div>

        <div className="mt-6">
          <Link to="/dashboard" className="text-primary hover:underline text-sm">← Back to Dashboard</Link>
        </div>
      </div>
    </div>
  )
}
